import { CampaignHasMoreThanOneAdPoolCampaignFragmentData } from 'components/Campaign/fragments';
import { AdFormValues } from 'hooks/useFormUtils';
import { CampaignUrlWarningDialogCampaignFragmentData } from 'shared/CampaignUrlWarningDialog/fragments';
import { AdPoolNode, CampaignNode, GoogleDynamicSearchAdNode } from 'typeDeclarations/graphql/nodes';
import {
  GoogleDynamicSearchAdFormData,
  GoogleDynamicSearchAdPreviewCampaignExtensionsCampaignFragmentData,
  GoogleDynamicSearchAdPreviewFragmentData,
  GoogleDynamicSearchAdRestrictionsData,
} from '../models/fragments';

export const NUM_MAX_CALLOUT_EXTENSIONS_GOOGLE_DYNAMIC = 4;
export const NUM_MAX_SNIPPET_EXTENSIONS_GOOGLE_DYNAMIC = 3;
export const NUM_MAX_LOCATION_EXTENSIONS_GOOGLE_DYNAMIC = 1;
export const NUM_MAX_SITELINK_EXTENSIONS_GOOGLE_DYNAMIC = 4;
export const NUM_MAX_SNIPPET_EXTENSIONS_TEXT_GOOGLE_DYNAMIC = 3;

export interface GoogleDynamicSearchAdFormValues extends AdFormValues {
  description: string;
  description2: string;
  destinationUrl: string;
}

export interface GoogleDynamicSearchAdEditorVariables {
  id: string | null;
  includeAd: boolean;
  campaignId: string;
  snippetExtensionsAmount: number;
  calloutExtensionsAmount: number;
  locationExtensionsAmount: number;
  sitelinkExtensionsAmount: number;
  calloutExtensionsOrderBy: string;
  snippetExtensionsOrderBy: string;
  locationExtensionsOrderBy: string;
  sitelinkExtensionsOrderBy: string;
}

export interface GoogleDynamicSearchAdEditorData {
  googleDynamicSearchAdRestrictions: GoogleDynamicSearchAdRestrictionsData;
  googleDynamicSearchAd?:
    | null
    | (Pick<GoogleDynamicSearchAdNode, 'id' | 'modified' | 'name'> &
        GoogleDynamicSearchAdFormData &
        GoogleDynamicSearchAdPreviewFragmentData & {
          adPool: null | Pick<AdPoolNode, 'id' | 'modified' | 'name'>;
        });
  campaign:
    | null
    | (Pick<CampaignNode, 'id' | 'modified'> &
        CampaignUrlWarningDialogCampaignFragmentData &
        CampaignHasMoreThanOneAdPoolCampaignFragmentData &
        GoogleDynamicSearchAdPreviewCampaignExtensionsCampaignFragmentData);
}

export interface ValidateGoogleDynamicSearchAdDestinationUrlVariables {
  adId?: string;
  adPoolId?: string;
  campaignId?: string;
  destinationUrl?: string;
}

export interface ValidateGoogleDynamicSearchAdVariables {
  adId?: string;
  adPoolId?: string;
  campaignId?: string;
  description?: string;
  description2?: string;
  destinationUrl?: string;
}
